var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6875 14.8125C17.6875 14.0666 17.9838 13.3512 18.5113 12.8238C19.0387 12.2963 19.7541 12 20.5 12C21.2459 12 21.9613 12.2963 22.4887 12.8238C23.0162 13.3512 23.3125 14.0666 23.3125 14.8125V19.5C23.3125 20.2459 23.0162 20.9613 22.4887 21.4887C21.9613 22.0162 21.2459 22.3125 20.5 22.3125C19.7541 22.3125 19.0387 22.0162 18.5113 21.4887C17.9838 20.9613 17.6875 20.2459 17.6875 19.5V14.8125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2812 18.0938C16.4056 18.0938 16.5248 18.1431 16.6127 18.231C16.7006 18.319 16.75 18.4382 16.75 18.5625V19.5C16.75 20.4946 17.1451 21.4484 17.8483 22.1517C18.5516 22.8549 19.5054 23.25 20.5 23.25C21.4946 23.25 22.4484 22.8549 23.1517 22.1517C23.8549 21.4484 24.25 20.4946 24.25 19.5V18.5625C24.25 18.4382 24.2994 18.319 24.3873 18.231C24.4752 18.1431 24.5944 18.0938 24.7188 18.0938C24.8431 18.0938 24.9623 18.1431 25.0502 18.231C25.1381 18.319 25.1875 18.4382 25.1875 18.5625V19.5C25.1875 20.6621 24.7559 21.7827 23.9764 22.6445C23.1968 23.5063 22.125 24.0479 20.9688 24.1641V26.0625H23.7812C23.9056 26.0625 24.0248 26.1119 24.1127 26.1998C24.2006 26.2877 24.25 26.4069 24.25 26.5313C24.25 26.6556 24.2006 26.7748 24.1127 26.8627C24.0248 26.9506 23.9056 27 23.7812 27H17.2188C17.0944 27 16.9752 26.9506 16.8873 26.8627C16.7994 26.7748 16.75 26.6556 16.75 26.5313C16.75 26.4069 16.7994 26.2877 16.8873 26.1998C16.9752 26.1119 17.0944 26.0625 17.2188 26.0625H20.0312V24.1641C18.875 24.0479 17.8032 23.5063 17.0236 22.6445C16.2441 21.7827 15.8125 20.6621 15.8125 19.5V18.5625C15.8125 18.4382 15.8619 18.319 15.9498 18.231C16.0377 18.1431 16.1569 18.0938 16.2812 18.0938Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic_icon.289c5666540454828eaee0e90d64fa0e.svg";
export { ForwardRef as ReactComponent };